import React, { useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const faqs = [
  { question: "How does the Lifetime Warranty work?", answer: "If our gear fails due to a manufacturing defect or materials issue, we will repair or replace it at no cost. Normal wear and tear is repaired at a reasonable price." },
  { question: "Are your products truly weatherproof?", answer: "Our PRO and EXTREME rated products undergo rigorous hydrostatic and wind tunnel testing. The Apex line is guaranteed waterproof up to 28,000mm." },
  { question: "Do you ship internationally?", answer: "Yes. We ship worldwide. Expeditions require gear everywhere. Customs fees may apply depending on your location." },
  { question: "How do I care for GORE-TEX material?", answer: "Machine wash warm (105°F/40°C) with high-performance wash. Tumble dry on medium heat to reactivate the DWR coating." }
];

const FAQ = () => {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section className="py-20 bg-zinc-950">
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="text-4xl font-black uppercase tracking-tighter mb-10 border-l-4 border-orange-600 pl-4">
          Intel & Support
        </h2>
        
        <div className="space-y-4">
          {faqs.map((faq, idx) => (
            <div 
              key={idx} 
              className={`border border-zinc-800 transition-colors ${openIdx === idx ? 'bg-zinc-900 border-zinc-700' : 'bg-transparent'}`}
            >
              <button 
                className="w-full p-6 text-left flex justify-between items-center focus:outline-none"
                onClick={() => setOpenIdx(openIdx === idx ? -1 : idx)}
              >
                <span className="font-bold uppercase tracking-wide text-lg">{faq.question}</span>
                <SafeIcon 
                  icon={FiChevronDown} 
                  className={`w-6 h-6 text-orange-500 transition-transform duration-300 ${openIdx === idx ? 'rotate-180' : ''}`} 
                />
              </button>
              {openIdx === idx && (
                <div className="px-6 pb-6 text-zinc-400 font-medium leading-relaxed border-t border-zinc-800 pt-4">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;